import { useEffect, useState } from "react";
import appAPI, { baseURL } from "../../api/service";
import { useNavigate } from "react-router-dom";
import Loader from "../helpers/loader/loader";
import Back from "../helpers/back";
import toast from "react-hot-toast";

const Offers = () => {
  const nav = useNavigate();
  const [search, setSearch] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    async function fetch() {
      try {
        const response = await appAPI.getUser(window.Telegram.WebApp.initDataUnsafe.user.id);
        setUserInfo(response.data[0]);
      } catch (e) {
        console.log(e);
      }
    }
    fetch();
  }, []);

  if (userInfo === null) return <Loader />;
  return (
    <div className={`main_container `}>
      <Back />
      <div className={`container`}>
        <div className="header">{/*<h1>Актуальные товары</h1>*/}</div>
        <div
              className="buttonTo comm"
              style={{
                margin: "10px 0",
                background: "transparent",
                border: "1px solid #0088cc",
                color: "black",
              }}
              onClick={() => nav("/create")}
            >
               Разместить товар
            </div>
        <div className={`catalog_v2`} style={{ marginTop: "10px" }}>
          {userInfo.attributes.offers.data.length !== 0 ? (
            userInfo.attributes.offers.data.map((work) => {
              return (
                <div
                  className="cart_v2"
                  onClick={() => nav(`/orders/${work.id}`)}
                  style={{ alignItems: "stretch" }}
                >
                  {work.attributes.image.data && (
                    <img
                      src={baseURL + work.attributes.image.data.attributes.url}
                    />
                  )}
                  <div className="text">
                    <div className="title_v2">{work.attributes.name}</div>
                    <div className="price_v2">
                      Артикул: {work.attributes.article}
                    </div>
                    <div className="price_v2">
                      Осталось сделок: {work.attributes.dealsLimit}
                    </div>
                  </div>
                  <svg
                    className="arrow_icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#000000"
                    stroke-width="0.00024000000000000003"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        d="M9.71069 18.2929C10.1012 18.6834 10.7344 18.6834 11.1249 18.2929L16.0123 13.4006C16.7927 12.6195 16.7924 11.3537 16.0117 10.5729L11.1213 5.68254C10.7308 5.29202 10.0976 5.29202 9.70708 5.68254C9.31655 6.07307 9.31655 6.70623 9.70708 7.09676L13.8927 11.2824C14.2833 11.6729 14.2833 12.3061 13.8927 12.6966L9.71069 16.8787C9.32016 17.2692 9.32016 17.9023 9.71069 18.2929Z"
                        fill="#b8b8b8"
                      ></path>{" "}
                    </g>
                  </svg>
                </div>
              );
            })
          ) : (
            <div
              style={{ textAlign: "center", marginTop: "30px", width: "100%" }}
            >
              Товары не найдены
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Offers;
